<template>
	<div>
		<v-stepper alt-labels v-model="step" elevation="0" class="mb-12">
			<v-stepper-header elevation="0" color="#ddd" style="background-color: #eee;box-shadow: none;">
				<v-stepper-step step="1" :complete="localData.status.stepCategory > 0" color="secondary">
					انتخاب وام و اقساط
				</v-stepper-step>

				<v-divider></v-divider>

				<v-stepper-step :rules="[() => localData.status.systemRequestStatus !== 10]" step="2" :complete="localData.status.stepCategory > 5" color="secondary">
					تکمیل مدارک
					<small v-if="localData.status.systemRequestStatus === 10">نقص مدارک</small>
				</v-stepper-step>

				<v-divider></v-divider>

				<v-stepper-step step="3" :complete="localData.status.systemRequestStatus === 30" color="secondary">
					تعیین وضعیت
				</v-stepper-step>
			</v-stepper-header>

			<v-stepper-items>
				<v-stepper-content step="1">
					<v-form ref="form" class="ma-2" lazy-validation>
						<v-row>
							<v-col cols="12" md="6">
								<v-card class="pa-2" elevation="2">
									<h3 class="text-h6 mb-2">طرح وام مورد نظر خود را انتخاب کنید:</h3>
									<v-combobox v-model="localData.loanModel" outlined clearable required single-line return-object :items="loans" label="وام*" item-text="title" item-value="id" />
									<div style="" v-if="calculatorType == 0">
										<div style="padding: 10px;border-bottom: 1px dashed #eee;">
											<span>درصد بهره:</span>
											<span class="secondary--text mr-1">{{ localData.loanModel ? `${profit}%` : '-' }}</span>
										</div>
										<div style="padding: 10px;border-bottom: 1px dashed #eee;">
											<span>جریمه دیرکرد روزانه:</span>
											<span class="secondary--text mr-1">{{ localData.loanModel ? hasDelay ? 'دارد' : 'ندارد' : '-' }}</span>
										</div>
										<div style="padding: 10px;border-bottom: 1px dashed #eee;">
											<span>سود زودکرد روزانه:</span>
											<span class="secondary--text mr-1">{{ localData.loanModel ? hasEarly ? 'دارد' : 'ندارد' : '-' }}</span>
										</div>
										<div style="padding: 10px;border-bottom: 1px dashed #eee;" v-if="maxAmount">
											<span>سقف وام:</span>
											<span class="secondary--text mr-1">{{ maxAmount.toString().toPriceFormat() }}</span>
										</div>
										<div style="padding: 10px;border-bottom: 1px dashed #eee;" v-if="maxMonthGap">
											<span>حداکثر فاصله بین اقساط:</span><span class="secondary--text mr-1">{{ maxMonthGap }}</span>
										</div>
									</div>
									<div>
										<div style="padding: 10px;">
											<span>مدارک مورد نیاز:</span>
											<v-badge v-for="authorize in authorizations" :key="authorize.id" color="secondary" :content="authorize.title" inline>
											</v-badge>
										</div>
									</div>
								</v-card>
							</v-col>
							<v-col cols="12" md="6">
								<refah-beta-manager class="mb-3" :loan="localData.loanModel" :nationalCode="user.nationalCode" @update="refahUpdated" v-if="isRefahLoanModel" />
								<v-card class="pa-2 mb-5" elevation="2" v-if="!isRefahLoanModel || (isRefahLoanModel && refah)" :color="isRefahLoanModel ? '#eee' : 'transparent'">
									<h3 class="text-h6 mb-2">مبلغ وام مورد نظر خود را تعیین کنید:</h3>
									<loan-calculator :pureTitle="'خالص دریافتی مشتری'" v-model="localData" :paymentPeriod="refah ? refah.month : 0" panel="agent" :max="isRefahLoanModel && refah ? refah.max : 0" />
								</v-card>
								<v-card class="pa-2 mb-5 pt-4" v-if="!isRefahLoanModel || (isRefahLoanModel && refah)">
									<div class="mb-1">
										<label>شرح کالاها و خدمات:</label>
									</div>
									<v-textarea outlined rows="3" label="" v-model="localData.products" :rules="[(val) => !!val || 'شرح کالاها الزامی است', (val) => val && val.length < 1000 || 'حداکثر 1000 کاراکتر']"></v-textarea>
								</v-card>
								<v-card class="pa-2" elevation="2" color="#eee">
									<div v-if="isProductable">
										<div>نحوه دریافتی را مشخص کنید:</div>
										<div>
											<v-radio-group v-model="localData.chargeType" @change="chargeTypeChnaged">
												<v-radio color="secondary" :value="0" :label="`${agentLoan && agentLoan.cashTitle ? agentLoan.cashTitle : 'پول نقد'} ${agentLoan ? agentLoan.defaultCheckoutDays : ''} روزه (${agentLoan ? agentLoan.percent : 0}%)`"></v-radio>
												<div v-if="agentLoan" class="mb-2">
													<v-radio color="secondary" v-for="(other, oindex) in (agentLoan.otherPercents || [])" :key="oindex" :value="other" :label="`${agentLoan && agentLoan.cashTitle ? agentLoan.cashTitle : 'پول نقد'} ${other.checkoutDays} روزه (${other.percent}%)`"></v-radio>
												</div>
												<v-radio color="secondary" :value="5" :label="`${agentLoan && agentLoan.productTitle ? agentLoan.productTitle : 'کالا'} (${agentLoan ? agentLoan.productPercent : 0}%)`"></v-radio>
											</v-radio-group>
										</div>
									</div>
									<div class="d-flex secondary--text text-bold pa-2 text-right">
										<span>مبلغ قابل واریز به نماینده:</span>
										<span class="mr-2">{{ agentPayable }}</span>
									</div>
								</v-card>
							</v-col>
						</v-row>
					</v-form>
				</v-stepper-content>

				<v-stepper-content step="2">
					<div v-if="authorizeStepLoading" class="success--text text-h4 text-center">
						در حال دریافت اطلاعات ...
					</div>
					<v-alert type="success" outlined class="mb-1" v-if="!authorizeStepLoading && localData.status && localData.status.systemRequestStatus == 15">
						درخواست شما با موفقیت ثبت شد و در مرحله بررسی توسط کارشناس قرار گرفت.
					</v-alert>
					<v-alert type="success" outlined class="mb-1" v-else-if="authorizationItems.length === 0 && !authorizeStepLoading">وام دارای مدارک نمی باشد، جهت ثبت نهایی
						درخواست بر روی دکمه "ارسال درخواست به کارشناس" پایین فرم کلیک نمایید.</v-alert>
					<v-alert type="info" outlined v-else-if="!authorizeStepLoading">کاربر گرامی، پس از ثبت مدارک، بر روی دکمه "ارسال
						درخواست به کارشناس" پایین فرم کلیک نمایید.</v-alert>
					<v-row class="mt-8 justify-center">
						<v-col cols="12" sm="12" md="11" class="px-5" v-for="(auth, index) in authorizationItems" :key="auth.id + index">
							<v-card class="mb-4" elevation="4">
								<div class="text-center text-h4 white--text pa-2 grey" style="border-top-left-radius: 10px; border-top-right-radius: 10px">
									{{ auth.authorizationItem.title }}
								</div>
								<div class="pa-3">
									<div class="text-center" style="border-bottom: 1px dashed #ddd;white-space: pre-line;" v-if="auth.authorizationItem.description && ![5, 6, 7].includes(auth.authorizationItem.systemType)" v-html="replaceToLink(auth.authorizationItem.description)">

									</div>
									<v-row class="mt-2">
										<v-col v-if="auth.authorizationItem.systemType === 1" cols="12" md="9" class="text-center">
											<IceManager :isAdmin="false" :isSummery="true" :userId="user.id" />
										</v-col>
										<v-col v-if="auth.authorizationItem.systemType === 2" cols="12" md="9" class="text-center">
											<IranValidityManager :isAgent="true" :userId="user.id" :isSummery="false" />
										</v-col>
										<v-col v-if="auth.authorizationItem.systemType === 4" cols="12" md="9" class="text-center">
											<RefahAuthorizationItem :data="auth.memberDescription" />
										</v-col>
										<v-col v-if="auth.authorizationItem.systemType === 5" cols="12" md="9" class="text-center">
											<v-row v-for="(attachment, index) in auth.attachments.filter(x => x.rowState !== 'deleted')" :key="attachment.id + index" style="border-bottom: 1px dashed #ccc;">
												<v-col cols="12" md="3">
													<ImageUploader style="width: 120px;" :ref="'imageUploader' + auth.id + index" :editable="checkIsEditable(auth.status)" v-model="attachment.base64" :fileUrl="attachment.fileUrl" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(attachment.base64)" @delete="() => attachment.attachment = ''" />
												</v-col>
												<v-col cols="12" md="9">
													<DigitalSignSms :auth="auth" :member="user" area="agent" />
												</v-col>
											</v-row>
										</v-col>
										<v-col v-if="auth.authorizationItem.systemType === 6" cols="12" md="12" class="text-center">
											<v-row v-for="(attachment, index) in auth.attachments.filter(x => x.rowState !== 'deleted')" :key="attachment.id + index" style="border-bottom: 1px dashed #ccc;">
												<v-col cols="12" md="12">
													<ThirdPersonDigitalSignSms :thirdPersonAssuranceAuthorizationItem="auth.thirdPersonAssuranceAuthorizationItem" :auth="auth" area="agent" @updated="reloadAuthorizeItem(auth.id)" />
												</v-col>
											</v-row>
										</v-col>
										<v-col v-else-if="auth.authorizationItem.systemType === 7" cols="12" md="12" class="text-center">
											<DigitalSignEmzame :emzameContractAuthorizationItem="auth.emzameContractAuthorizationItem" :auth="auth" area="agent" @updated="reloadAuthorizeItem(auth.id)" :memberId="user.id" />
										</v-col>
										<v-col v-if="auth.authorizationItem.systemType === 10" cols="12" md="12" class="text-center">
											<v-row class="justify-center">
												<v-col cols="12" md="8">
													<MemberAuthorization :auth="auth" :member="user" area="agent" />
												</v-col>
											</v-row>
										</v-col>
										<v-col v-if="auth.authorizationItem.systemType === 30" cols="12" md="9" class="text-center">
											<MemberInquiry :type="11" :userLoanRequestAuthorizationItem="auth" :memberId="user.id" />
										</v-col>
										<v-col v-if="auth.authorizationItem.systemType === 0" cols="12" md="9" class="py-0 text-center" style="border-left: 1px dashed #ccc;">
											<v-row v-for="(attachment, index) in auth.attachments.filter(x => x.rowState !== 'deleted')" :key="attachment.id + index" style="border-bottom: 1px dashed #ccc;">
												<v-col cols="12" md="3">
													<ImageUploader style="width: 120px;" :ref="'imageUploader' + auth.id + index" :downloadFileName="auth.authorizationItem.title + '-' + memberFullName" :downloadable="true" :editable="checkIsEditable(auth.status)" :fileUrl="attachment.fileUrl" v-model="attachment.base64" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(attachment.base64)" @delete="() => attachment.attachment = ''" />
												</v-col>
												<v-col cols="12" md="8">
													<div class="text-right" v-if="!checkIsEditable(auth.status)">
														<div>توضیحات:</div>
														<div class="grey--text" style="white-space: pre-line">
															{{ attachment.memberDescription }}
														</div>
													</div>
													<div v-else>
														<v-text-field v-model="attachment.memberDescription" label="توضیحات در صورت لزوم اینجا وارد شود" :error-messages="errorMessages" :rules="[(val) => val.length < 1000 || 'حداکثر 1000 کاراکتر']" />
													</div>
												</v-col>
												<v-col cols="12" md="1" class="d-flex flex-column justify-center" v-if="checkIsEditable(auth.status)">
													<v-btn v-if="index > 0" class="ms-2" x-small icon color="pink" title="حذف" @click="deleteAttachment(auth.attachments, index)">
														<v-icon dark>
															mdi-trash-can-outline
														</v-icon>
													</v-btn>
												</v-col>
											</v-row>
											<div class="mb-2 mt-5">
												<v-btn small @click="addAttachment(auth.attachments)">افزودن ردیف پیوست</v-btn>
											</div>
											<div v-if="auth.adminDescription" class="red--text">
												نظر کارشناس:
												<div style="white-space: pre-line">
													{{ auth.adminDescription }}
												</div>
											</div>
										</v-col>
										<v-col cols="12" md="3" v-if="![6, 7].includes(auth.authorizationItem.systemType)" class="py-0 d-flex justify-center align-center flex-column">
											<v-btn class="mb-3" :loading="submitAuthorizeItemLoading === auth.id" prepend-icon="mdi-check" @click="submitAuthorizeItem(auth, index)" v-if="checkIsEditable(auth.status)" color="secondary" small dark>
												<template v-slot:prepend>
													<v-icon color="success" small>mdi-check</v-icon>
												</template>
												ثبت
											</v-btn>
											<!-- <v-sheet :color="statusColor(auth.status)" dark class="px-2 rounded-lg">
												{{ auth.status_Text }}
											</v-sheet> -->
											<v-badge :color="statusColor(auth.status)" :content="auth.status_Text" inline>
											</v-badge>
										</v-col>
									</v-row>
								</div>
							</v-card>
						</v-col>
					</v-row>
				</v-stepper-content>

				<v-stepper-content step="3">
					<div>
						<div class="black--text mt-2 text-center">
							وضعیت:
						</div>
						<div cols="12" class="text-center" style="border-bottom: 1px dashed #aaa;">
							{{ localData.str_Status }}
						</div>
						<div class="black--text mt-2 text-center">
							تاریخ ثبت درخواست:
						</div>
						<div cols="12" class="text-center" style="border-bottom: 1px dashed #aaa;">
							{{ (localData.requestDate_Persian || {}).date }}
						</div>
						<div class="black--text mt-2 text-center">
							نظر کارشناس:
						</div>
						<div cols="12" class="text-center">
							{{ (localData.adminDescription || 'تاکنون کارشناس نظری ثبت نکرده است.') }}
						</div>
						<div cols="12" class="text-center">
							وضعیت تحویل شدن مدارک فیزیکی به شرکت:
							{{ localData.isPhysicalDocsDelivered ? 'به شرکت رسیده' : 'به شرکت نرسیده' }}
						</div>
					</div>
				</v-stepper-content>
			</v-stepper-items>
		</v-stepper>
		<div class=" mt-4 d-flex" style="position: absolute;
			bottom: 0px;
			background: white;
			left: 0;
			right: 0;
			padding: 15px 35px;
			border-top: 1px solid #d9d9d9;">
			<v-btn color="info" dark @click="preStep()" v-if="step > 1" small>
				<v-icon>mdi-chevron-right</v-icon>
				مرحله قبل
			</v-btn>
			<v-spacer />
			<v-btn color="secondary" v-if="step === 2 && (localData.status.stepCategory === 5)" dark prepend @click="submit()" :loading="nextStepLoading">
				ارسال درخواست به کارشناس
			</v-btn>
			<v-spacer />
			<v-btn color="info" dark @click="nextStep()" :loading="nextStepLoading" :disabled="step === 2 && (localData.status.stepCategory === 5)" v-if="step < 3" small>
				مرحله بعد
				<v-icon>mdi-chevron-left</v-icon>
			</v-btn>
			<v-btn color="grey" dark @click="$emit('callbck', 'close')" v-if="step === 3" small>
				بستن
			</v-btn>
		</div>

		<v-dialog v-model="dialogCustomerProfile" scrollable persistent max-width="900px">
			<v-card>
				<v-card-title>
					<span class="headline">مشخصات کاربر</span>
					<v-spacer />
					<v-btn @click="dialogCustomerProfile = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-customer :data="selectedCustomer" v-if="dialogCustomerProfile" @callbck="callbck_customerprofile" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogCustomerProfileAlert" scrollable persistent max-width="450px">
			<v-card>
				<v-card-title>
					<span class="headline">توجه!</span>
					<v-spacer />
					<v-btn @click="dialogCustomerProfileAlert = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						اطلاعات پروفایل مشتری به صورت کامل تکمیل نشده است. لطفا ابتدا پروفایل را تکمیل نمایید.
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn color="blue" dark @click="profile">
						مشاهده و تکمیل پروفایل
					</v-btn>
					<v-spacer />
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogRefahOtp" scrollable persistent max-width="500px">
			<v-card>
				<v-card-title>
					<span class="headline">ثبت رمز پیامکی</span>
					<v-spacer />
					<v-btn @click="dialogRefahOtp = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<div>لطفا ابتدا از طریق فرم زیر کد تائیدیه پیامکی دریافت و ثبت کنید، ثبت این کد به منزله تائید قوانین و
							اجازه ایجاد پرونده فروش اقساطی در بانک رفاه می باشد. </div>
						<v-card color="#eee" class="px-2 d-flex justify-center">
							<div class="d-flex px-2 align-center " style="">
								<v-text-field v-model="localData.refahOtp" maxlength="5" label="کد تایید" />
								<v-btn v-if="sendCodeVisible" small class="mr-2" @click="sendRefahOTP" :loading="optLoading"><small>ارسال کد</small></v-btn>
								<Countdown class="black--text fs-h3" @finish="countDownFinished" ref="countdown" />
							</div>
						</v-card>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn color="blue" small dark @click="refahOtpSubmit()">
						تایید
					</v-btn>
					<v-spacer />
				</v-card-actions>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { get } from 'vuex-pathify'
	import { emptyId } from '@/util/emptyId'
	import ImageUploader from '@/components/uploader/ImageUploader'

	export default {
		name: 'ModifyRequestView',
		props: {
			data: { type: Object },
			user: { type: Object }
		},
		components: {
			ImageUploader,
			ConfirmDlg: () => import('@/components/Confirm'),
			'refah-beta-manager': () => import('@/components/RefahBetaManager'),
			'loan-calculator': () => import('@/components/LoanCalculator'),
			'modify-customer': () => import('./ModifyCustomer'),
			Countdown: () => import('@/components/Countdown'),
			IranValidityManager: () => import('@/components/loanAuthorizations/IranValidityManager'),
			IceManager: () => import('@/components/loanAuthorizations/IceManager.vue'),
			RefahAuthorizationItem: () => import('@/components/RefahAuthorizationItem.vue'),
			DigitalSignSms: () => import('@/components/loanAuthorizations/DigitalSignSms.vue'),
			ThirdPersonDigitalSignSms: () => import('@/components/loanAuthorizations/ThirdPersonDigitalSignSms.vue'),
			MemberAuthorization: () => import('@/components/loanAuthorizations/MemberAuthorization'),
			MemberInquiry: () => import('@/components/memberAuthorization/MemberInquiry.vue'),
			DigitalSignEmzame: () => import('@/components/loanAuthorizations/DigitalSignEmzame.vue'),
		},
		data() {
			return {
				errorMessages: '',
				localData: { amount: 10000000, installmentCount: 1, monthGap: 1, status: {}, products: '' },
				loans: [],
				step: 1,
				authorizationItems: [],
				nextStepLoading: false,
				overlayImgSrc: '',
				overlay: false,
				submitAuthorizeItemLoading: false,
				authorizeStepLoading: false,
				agent: null,
				dialogCustomerProfile: false,
				dialogCustomerProfileAlert: false,
				selectedCustomer: {},
				sendCodeVisible: true,
				refah: null,
				optLoading: false,
				dialogRefahOtp: false
			}
		},
		computed: {
			...get('agentAppSettings', {
				agentSettings: 'settings'
			}),
			calculatorType() {
				return this.agentSettings?.calculatorType || 0
			},
			hasDelay() {
				return this.localData.loanModel && this.localData.loanModel.delayPercent
			},
			hasEarly() {
				return this.localData.loanModel && this.localData.loanModel.earlyPercent
			},
			profit() {
				return this.localData.loanModel ? this.localData.loanModel.profitPercent : 0
			},
			authorizations() {
				return this.localData.loanModel?.agentLoanAuthorizationItems?.map(x => x.authorizationItem) || []
			},
			maxAmount() {
				if (!this.localData?.loanModel)
					return 0

			if (!this.localData.loanModel.allowedInstallments || !this.localData.loanModel.allowedInstallments.includes('['))
				return this.localData.loanModel.maxAmount || 0

			let arr = JSON.parse(this.localData.loanModel.allowedInstallments)
			let max = Math.max(...arr.map(obj => obj.max))
			return max || this.localData.loanModel.maxAmount || 0
		},
		maxMonthGap() {
			return this.localData.loanModel ? this.localData.loanModel.maxMonthGap : 0
		},
		agentPayable() {
			let percent = 0
			if (this.localData.chargeType === 5) {
				percent = this.agentLoan?.productPercent
			} else {
				percent = this.localData?.otherPercent ? this.localData.otherPercent.percent : this.agentLoan?.percent
			}
			if (!percent)
				percent = this.localData.loanModel?.agentPercent || 0
			if (!this.localData.amount)
				return
			return (this.localData.amount * percent / 100).toString().toPriceFormat()
		},
		agentLoan() {
			return this.agent?.agentLoans.find(x => x.loanId === this.localData.loanModel?.id)
		},
		isProductable() {
			return !!this.agentLoan
			// return true
		},
		memberFullName() {
			return this.user?.fullName || this.localData.memberModel?.fullName || ''
		},
		isRefahLoanModel() {
			return this.localData.loanModel?.agentLoanAuthorizationItems?.some(x => x.authorizationItem?.systemType === 4)
		}
	},
	mounted() {
		this.prepareData()
		this.loadAgent()
	},
	methods: {
		sendRefahOTP() {
			this.optLoading = true
			let data = {
				title: this.localData.products, // will be fill in server
				startDate: '0001-01-01', // will be fill in server
				amount: this.localData.installment * this.localData.installmentCount,
				numberOfInstallments: this.refah.month,
				nationalCode: this.user.nationalCode
			}
			api.post('member/UserRefahBeta/SendOtp', data)
				.then(response => {
					this.sendCodeVisible = false
					this.$refs.countdown.start()
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(() => {
					this.optLoading = false
				})
		},
		countDownFinished() {
			this.sendCodeVisible = true
		},
		validateRefahBeta() {
			if (!this.refah) {
				toast.error(`مدت بازپرداخت بر اساس توان استعلامی از بانک تعیین نشده است.`)
				return false
			}
			if (this.refah.credit < this.localData.mount) {
				toast.error(`مبلغ وام درخواستی از حداکثر توان خرید شما بیشتر است. حداکثر مبلغ قابل ثبت برای شما ${this.refah.max.toString().toPriceFormat()} تومان می باشد.`)
				return false
			}
			return true
		},
		loadAgent() {
			return api.get('agent/agent/get', null)
				.then(
					response => {
						this.agent = response
					})
				.catch(err => {
					toast.error(err.message)
				})
		},
		step1To2(ignoreRefahOtp = false) {
			if (!this.$refs.form.validate()) {
				return
			}
			if (!this.localData.loanModel) {
				toast.error('لطفا ابتدا نوع وام را انتخاب کنید.')
				return
			}
			if (this.maxAmount > 0 && this.localData.amount > this.maxAmount) {
				toast.error(`سقف مبلغ مجاز برای این نوع وام ${this.maxAmount.toString().toPriceFormat()} می باشد.`)
				return
			}
			if (this.maxMonthGap > 0 && this.localData.monthGap > this.maxMonthGap) {
				toast.error(`سقف مجاز فاصله بین اقساط برای این نوع وام ${this.maxMonthGap} می باشد.`)
				return
			}
			if (this.localData.status.stepCategory >= 5) {
				this.goToStep2()
				return
			}
			if (this.isRefahLoanModel) {
				if (!this.validateRefahBeta())
					return
				if (!ignoreRefahOtp) {
					this.dialogRefahOtp = true
					return
				}
			}
			this.nextStepLoading = true
			this.createOrUpdateLoanRequest().then(res => {
				this.goToStep2()
			}).catch(err => {

			}).finally(() => {
				this.nextStepLoading = false
			})

		},
		createOrUpdateLoanRequest() {
			return new Promise((resolve, reject) => {
				if (this.localData.id === emptyId)
					this.localData.userId = this.user.id
				if (this.localData.chargeType?.percent >= 0)
					this.localData.chargeType = 0
				this.localData.refahBetaInquiryAmount = this.refah?.credit
				api.post('agent/userLoanRequest/' + (this.localData.id === emptyId ? 'create' : 'edit'), this.localData)
					.then(response => {
						if (this.localData.id === emptyId) {
							this.localData.status = response.status
							this.localData.str_Status = response.status.title
							this.localData.requestDate_Persian = response.requestDate_Persian
							this.localData.requestDate = response.requestDate
							this.$emit('callbck', 'refresh')
						}
						this.localData.id = response.id
						resolve()
					})
					.catch(err => {
						if (err.message === 'Profile Completion Error') {
							this.nextStepLoading = false
							this.profileAlert()
							return
						}
						toast.error(err.message)
						reject()
					})
			})
		},
		goToStep2() {
			if (this.localData.id === emptyId)
				return
			this.step = 2
			this.authorizeStepLoading = true
			api.get('member/UserLoanRequestAuthorizationItem/ListByUserLoanRequestId/' + this.localData.id, null)
				.then(response => {
					this.authorizationItems = response
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(() => {
					this.authorizeStepLoading = false
				})
		},
		goToStep3() {
			this.step = 3
		},
		step2To3() {
			this.goToStep3()
		},
		prepareData() {
			if (!this.data) {
				this.data = { id: emptyId }
			}
			if (!this.data.id) {
				this.data.id = emptyId
			}

			this.loadLoans().then(x => {
				api.get('agent/userLoanRequest/get/' + this.data.id, null)
					.then(
						response => {
							this.localData = response
							if (this.localData.otherPercent) {
								this.localData.chargeType = this.localData.otherPercent
							}
							if (response.id === emptyId) {
								this.localData.amount = 10000000
								this.localData.installmentCount = 1
								this.localData.monthGap = 1
							}
							if (this.data.id === emptyId)
								Object.assign(this.localData, this.data)
							else {
								this.localData.loanModel = this.loans.find(x => x.id === this.localData.loanModel.id)
								if (this.localData.status.stepCategory > 5)
									this.step = 3
								else if (this.localData.status.stepCategory === 5)
									this.goToStep2()
							}
						})
					.catch(err => {
						toast.error(err.message)
					})
			}).catch(err => { })
		},
		loadLoans() {
			return api.get('agent/userLoanRequest/loanslist', null)
				.then(
					response => {
						this.loans = response.map(item => ({
							...item,
							planTitle: `${item.planTitle} (کد طرح: ${item.code})`
						}))
					})
				.catch(err => {
					toast.error(err.message)
				})
		},
		nextStep() {
			switch (this.step) {
				case 1:
					this.step1To2()
					break
				case 2:
					this.step2To3()
					break
				default:
					break
			}
		},
		preStep() {
			switch (this.step) {
				case 1:
					break
				case 2:
					this.step = 1
					break
				case 3:
					this.goToStep2()
					break
				default:
					break
			}
		},
		viewImage(img) {
			this.overlay = true
			this.overlayImgSrc = img
		},
		submitAuthorizeItem(auth, index) {
			const formData = new FormData()
			for (let i = 0; i < auth.attachments.length; i++) {
				var fileUploader = Array.isArray(this.$refs['imageUploader' + auth.id + i]) ? this.$refs['imageUploader' + auth.id + i][0] : null

				if (fileUploader && fileUploader.hasFile()) {
					formData.append(`Attachments[${i}].File`, fileUploader.getFile())
				}
				formData.append(`attachments[${i}][id]`, auth.attachments[i].id)
				formData.append(`attachments[${i}][memberDescription]`, auth.attachments[i].memberDescription)
				formData.append(`attachments[${i}][attachment]`, auth.attachments[i].attachment)
				formData.append(`attachments[${i}][rowState]`, auth.attachments[i].rowState)
			}
			formData.append('id', auth.id)
			this.submitAuthorizeItemLoading = auth.id
			api.post('member/UserLoanRequestAuthorizationItem/edit', formData, { contentType: 'multipart/form-data' })
				.then(response => {
					toast.success('اطلاعات با موفقیت ذخیره شد.')
					if (auth.id === emptyId) {
						auth.id = response.id
					}
					// if (fileUploader && fileUploader.hasFile()) {
					// 	fileUploader.toBase64(fileUploader.getFile()).then(res => {
					// 		auth.base64 = res
					// 	})
					// }
					auth.status_Text = response.status_Text
					auth.status = response.status
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => { this.submitAuthorizeItemLoading = '' })
		},
		checkIsEditable(status) {
			return status != 10 && status != 20
		},
		statusColor(status) {
			switch (status) {
				case 0:
					return 'grey'
				case 5:
					return '#c981cb'
				case 15:
					return 'error'
				case 20:
					return 'success'
				default:
					return 'grey'
			}
		},
		submit() {
			if (this.authorizationItems.some(x => x.status < 5)) {
				toast.error('لطفا ابتدا همه مدارک را ثبت کنید.')
				return
			}
			this.nextStepLoading = true
			api.post('agent/userLoanRequest/submit', this.localData)
				.then(response => {
					this.localData.status = response
					this.localData.str_Status = response.title
					this.nextStep()
					this.$emit('callbck', 'refresh')
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(f => {
					this.nextStepLoading = false
				})
		},
		addAttachment(attachments) {
			attachments.push({
				id: emptyId,
				rowState: 'new',
				attachment: '',
				memberDescription: '',
				base64: '',
				AttachmentByAdmin: false,
			})
		},
		deleteAttachment(attachments, index) {
			if (index < attachments.length) {
				if (attachments[index].rowState === 'new')
					attachments.splice(index, 1)
				else
					attachments[index].rowState = 'deleted'
			}
		},
		replaceToLink(text) {
			if (!text)
				return ''
			return text.replace(
				/((http|https|ftp|ftps)\:\/\/[a-zA-Z0-9\-\.]+\.[a-zA-Z]{2,3}(\/\S*)?)/g,
				'<a href="$1" target="_blank">$1</a>'
			)
		},
		profileAlert() {
			this.dialogCustomerProfileAlert = true
		},
		profile() {
			if (!this.user?.id) { return }
			this.selectedCustomer = { id: this.user.id }
			this.dialogCustomerProfileAlert = false
			this.dialogCustomerProfile = true
		},
		callbck_customerprofile(result) {
			this.dialogCustomerProfile = false
			this.dialogCustomerProfileAlert = false
			this.nextStep()
		},
		chargeTypeChnaged(e) {
			this.localData.otherPercent = e == 5 || e == 0 ? null : e
			this.localData.chargeTypeTitle = e == 5 ? (this.agentLoan.productTitle || 'کالا') : (this.agentLoan.cashTitle || 'پول نقد')
		},
		refahUpdated(refah) {
			this.refah = refah
			if (refah)
				this.localData.loanModel.maxAmount = refah.max
		},
		refahOtpSubmit() {
			if (!this.localData.refahOtp) {
				toast.error(`کد تاییدیه وارد نشده است.`)
				return
			}
			this.dialogRefahOtp = false
			this.step1To2(true)
		},
		reloadAuthorizeItem(id) {
			this.submitAuthorizeItemLoading = id
			api.get('member/UserLoanRequestAuthorizationItem/get/' + id, {})
				.then(response => {
					let index = this.authorizationItems.findIndex(x => x.id === id)
					if (index > -1)
						this.authorizationItems.splice(index, 1, response)
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => { this.submitAuthorizeItemLoading = '' })
		},
	},
}
</script>

<style></style>
